module.exports = __webpack_public_path__ + "static/media/design.8a74c24d.svg";